import { callService, goTo } from '../tools';
const msgError = "hubo un error";

export const sinValidarLiga = () => {
    return dispatch => {
        dispatch({ "type": "LOADER_HIDE" });
        dispatch({
            "type": "RECUPERAR_SET_PASO",
            "paso": "formnm"
        });
    }
}

export const validarLiga = (uid, time, status, token) => {
    localStorage.setItem("esMoral", "0");
    return dispatch => {
        new callService({
            service: 'olvideContrasena.validarUsuario',
            "secure": true,
            data: {
                "uid": uid,
                "date": time,
                "estatus": status,
                "token": token 
            }
        }).execute().then(body => {
            if (body.hasOwnProperty('error')) {
                dispatch({
                    "type": "RECUPERAR_SET_PASO",
                    "paso": "error"
                });
            } else {
                dispatch({
                    "type": "RECUPERAR_SET_UID",
                    "uid": body.uid
                });
                dispatch({
                    "type": "RECUPERAR_SET_ESTATUS",
                    "estatus": body.estatus
                });

                if (body.estatus === "nm") {
                    dispatch({ "type": "LOADER_HIDE" });
                    dispatch({
                        "type": "RECUPERAR_SET_PASO",
                        "paso": "formnm"
                    });
                }
            }
        }).catch(error => {
            console.log(msgError, error);
            dispatch({ "type": "LOADER_HIDE" });

            if(error.message.mensaje.includes("esta liga ya fue utilizada") ){
                localStorage.setItem("ligaUtilizada", "si");
                dispatch({
                    "type": "RECUPERAR_SET_PASO",
                    "paso": "expiro"
                });
            } else if (error.hasOwnProperty('message') && error.message !== "") {
                dispatch({
                    "type": "RECUPERAR_SET_PASO",
                    "paso": "expiro"
                });
            } else {
                dispatch({
                    "type": "RECUPERAR_SET_PASO",
                    "paso": "error"
                });
            }

        });
    }
}

export const actualizarDatos = (datos, tags) => {
    return dispatch => {
        new callService({
            service: 'olvideContrasena.actualizarDatos',
            "secure": true,
            data: datos
        }).execute().then(body => {
            dispatch({ "type": "LOADER_HIDE" });

            if (body.hasOwnProperty('error')) {
                dispatch({
                    "type": "MODAL_ALERT_MESSAGES_SHOW",
                    "titulo": "Error",
                    "mensaje": "Tuvimos un error"
                });
            }
            else {
                if (tags.estatus == "m") {
                    dispatch({ "type": "EVENT_UMIGRADO_SEGURIDAD_CORRECTOS", "flujo": "UsuarioMigrado", "dispositivo": tags.dispositivo });
                }
                else {
                    dispatch({ "type": "EVENT_REGISTRO_SIG-SEGURIDAD-CORRECTOS", "flujo": "UsuarioRegistro", "dispositivo": tags.dispositivo });
                }
                dispatch({ "type": "RECUPERAR_SET_PASO", "paso": "contrato" });
            }
        }).catch(error => {
            console.log(msgError, error);
            dispatch({ "type": "LOADER_HIDE" });
            console.log(error);
            var mensaje = "Hubo un error al actualizar los datos. Favor de intentar más tarde.";
            if (error.message.codigoError === 'eCl00026') {
                mensaje = "Lo sentimos, por su seguridad no puede introducir contraseñas anteriores.";
            }
            dispatch({
                "type": "MODAL_ALERT_MESSAGES_SHOW",
                "titulo": "Error",
                "mensaje": mensaje
            });
        });
    }
}

export const actualizarPassword = (uid, pass, dispositivo) => {
    return dispatch => {
        new callService({
            service: 'olvideContrasena.actualizarPassword',
            "secure": true,
            data: {
                "uid": uid,
                "pass": pass
            }
        }).execute().then(body => {
            dispatch({ "type": "LOADER_HIDE" });
            
            if (body.hasOwnProperty("error")) {
                dispatch({
                    "type": "MODAL_ALERT_MESSAGES_SHOW",
                    "titulo": "Error",
                    "mensaje": "Tuvimos un error"
                });
            }
            else {
                dispatch({ "type": "RECUPERAR_SET_PASO", "paso": "exito" });
                dispatch({ "type": "EVENT_RECUPERARCONTRASEÑA_RESTABLECER_DCORRECTOS", "flujo": "RecuperarContraseña", "dispositivo": dispositivo });
            }
        }).catch(error => {
            console.log(msgError, error);
            dispatch({ "type": "LOADER_HIDE" });
            console.log(error);
            var mensaje = "Hubo un error al resetear el password. Favor de intentar más tarde.";
            if (error.message.codigoError === 'eCl00026') {
                mensaje = "Lo sentimos, por su seguridad no puede introducir contraseñas anteriores.";
            }
            dispatch({
                "type": "MODAL_ALERT_MESSAGES_SHOW",
                "titulo": "Error",
                "mensaje": mensaje
            });
        });
    }
}

export const aceptoContrato = (uid) => {
    return dispatch => {
        new callService({
            service: 'olvideContrasena.aceptoContrato',
            "secure": true,
            data: {
                "uid": uid,
                "dato": true
            }
        }).execute().then(body => {
            dispatch({ "type": "LOADER_HIDE" });
            
            if (body.hasOwnProperty('error')) {
                dispatch({
                    "type": "MODAL_ALERT_MESSAGES_SHOW",
                    "titulo": "Error",
                    "mensaje": "Tuvimos un error"
                });
            }
            else if (body.aceptacionContratoMEClienteResponse.banExito) {
                dispatch({
                    "type": "RECUPERAR_SET_PASO",
                    "paso": "confidencialidad"
                });
            }
        }).catch(error => {
            console.log(msgError, error);
            dispatch({ "type": "LOADER_HIDE" });
            console.log(error);
            dispatch({
                "type": "MODAL_ALERT_MESSAGES_SHOW",
                "titulo": "Error",
                "mensaje": "Hubo un error al aceptar el contrato. Favor de intentar más tarde."
            });
        });
    }
}

export const aceptoConfidencialidad = (uid, dato) => {
    return dispatch => {
        dispatch({ "type": "RECUPERAR_SET_EVENT", "evento": "acepto-" + dato });
        new callService({
            service: 'olvideContrasena.aceptoConfidencialidad',
            "secure": true,
            data: {
                "uid": uid,
                "dato": dato
            }
        }).execute().then(body => {
            dispatch({ "type": "LOADER_HIDE" });
            
            if (body.hasOwnProperty('error')) {
                dispatch({
                    "type": "MODAL_ALERT_MESSAGES_SHOW",
                    "titulo": "Error",
                    "mensaje": "Tuvimos un error"
                });
            }
            else if (body.aceptacionDatosPersonalesClienteResponse.banExito) {
                dispatch({
                    "type": "RECUPERAR_SET_PASO",
                    "paso": "exito"
                });
            }
        }).catch(error => {
            console.log(msgError, error);
            dispatch({ "type": "LOADER_HIDE" });
            console.log(error);
            dispatch({
                "type": "MODAL_ALERT_MESSAGES_SHOW",
                "titulo": "Error",
                "mensaje": "Hubo un error al aceptar la confidencialidad. Favor de intentar más tarde."
            });
        });
    }
}

export const noaceptoContrato = (uid) => {
    return dispatch => {
        new callService({
            service: 'miPerfil.cancelarCuenta',
            "secure": true,
            data: {
                "clienteUnico": uid
            }
        }).execute().then(body => {
            dispatch({ "type": "LOADER_HIDE" });
            
            if (body.hasOwnProperty('error')) {
                dispatch({
                    "type": "MODAL_ALERT_MESSAGES_SHOW",
                    "titulo": "Error",
                    "mensaje": "Tuvimos un error"
                });
            }
            else {
                dispatch({ "type": "RECUPERAR_RESET_PASO" });
                goTo("login");
            }
        }).catch(error => {
            console.log(msgError, error);
            dispatch({ "type": "LOADER_HIDE" });
            console.log(error);
            dispatch({
                "type": "MODAL_ALERT_MESSAGES_SHOW",
                "titulo": "Error",
                "mensaje": "Hubo un error. Favor de intentar más tarde."
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/gnp-recuperar-contrasenia/servicios.act.js